import type { ReactElement } from 'react';

const NOTICES = [
  '계정 정보(이메일·이름)는 즉시 지워지고 같은 계정으로 다시 로그인할 수 없어요.',
  '진행 중인 견적 요청은 취소돼요.',
  '결제 대기 중인 주문은 취소되고, 결제가 끝나 제작·배송 중인 주문은 그대로 진행되며 진행 상황은 이메일로 안내돼요.',
  '작성한 후기는 삭제돼요.',
  '저장한 디자인은 30일 뒤 완전히 삭제돼요.',
  '결제·계약 기록은 관련 법령에 따라 보관돼요.',
] as const;

/** 재가입 제한은 본인인증(CI)으로만 판정한다 — 본인인증을 쓰지 않는 동안에는 안내하지 않는다. */
const REJOIN_NOTICE = '탈퇴 후 90일 동안은 같은 본인인증으로 다시 가입할 수 없어요.';

export interface WithdrawNoticeListProps {
  /** 서버가 본인인증을 쓰는지 — true 일 때만 재가입 제한 줄을 보인다. */
  readonly identityRequired: boolean;
}

/** 탈퇴하면 일어나는 일 안내 — 서버 탈퇴 처리(주문·견적·후기·디자인·재가입 제한)와 같은 내용이다. */
export const WithdrawNoticeList = ({ identityRequired }: WithdrawNoticeListProps): ReactElement => (
  <ul className="flex flex-col divide-y divide-foreground/10 border-y border-foreground/10 text-sm">
    {(identityRequired ? [...NOTICES, REJOIN_NOTICE] : NOTICES).map((notice) => (
      <li key={notice} className="py-3 leading-relaxed">
        {notice}
      </li>
    ))}
  </ul>
);
